// src/components/Students/DeleteMultibleStudents.jsx
import React, { useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { deleteMultipleStudents } from "../../utils/API";
import { ErrorMsg, success } from "../../utils/Toast";

function DeleteMultibleStudents({ studentIds, userId, onDeleteSuccess }) {
  const [show, setShow] = useState(false);
  const [confirmText, setConfirmText] = useState("");
  const [loading, setLoading] = useState(false);

  const handleOpen = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setConfirmText("");
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      // const studentIds = students.map((student) => student._id);
      await deleteMultipleStudents(studentIds, userId);
      onDeleteSuccess();
      success("Students deleted successfully");
      handleClose();
    } catch (error) {
      console.error("Error deleting students:", error);
      ErrorMsg(error?.response?.data?.message || "Failed to delete students");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="danger"
        disabled={!studentIds || studentIds.length === 0}
        onClick={handleOpen}
      >
        Delete ({studentIds?.length || 0})
      </Button>

      <Modal show={show} onHide={handleClose} centered   onClick={(e) => e.stopPropagation()}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            You are about to delete <strong>{studentIds?.length}</strong>{" "}
            {studentIds?.length === 1 ? "student" : "students"}. This action cannot
            be undone.
          </p>
          <Form.Group>
            <Form.Label>
              Please type <code>confirm delete</code> to proceed:
            </Form.Label>
            <Form.Control
              type="text"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              placeholder="confirm delete"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleDelete}
            disabled={confirmText !== "confirm delete" || loading}
          >
            {loading ? "Deleting..." : "Confirm Delete"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DeleteMultibleStudents;
